// eslint-disable-next-line import/no-cycle
import { getUserData } from '@/auth/utils'
import { USER_TYPE_INTERNATIONAL } from '@/const/userType'

export default function internationalUsersOnly({ next, router }) {
  if (getUserData().usertype !== USER_TYPE_INTERNATIONAL && getUserData().usertype !== 'super') {
    return router.push('not-authorized')
  }

  return next()
}
